import { render, staticRenderFns } from "./container.vue?vue&type=template&id=680b62b1&"
import script from "./container.vue?vue&type=script&lang=js&"
export * from "./container.vue?vue&type=script&lang=js&"
import style0 from "./container.vue?vue&type=style&index=0&id=680b62b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports